/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const HaproxyStatsEnum = {
    GET_ALL_STATS: '/haproxy/stats',
    GET_ALL_FRONTENDS: '/haproxy/stats/frontends',
    GET_ALL_BACKENDS: '/haproxy/stats/backends',
    GET_ALL_RIPS: '/haproxy/stats/rips',
    GET_FRONTEND_STATS_BY_ID: (frontendId: string): string => {
        return '/haproxy/stats/frontend/' + frontendId;
    },
    GET_RIPS_STATS_BY_ID: (ripId: string): string => {
        return '/haproxy/stats/rips/' + ripId;
    },
    GET_RIPS_STATS_BY_BACKEND: (backendId: string): string => {
        return 'haproxy/stats/rips/backend/' + backendId;
    },
    GET_BACKEND_STATS_BY_ID: (backendId: string): string => {
        return 'haproxy/stats/backends/' + backendId;
    },
};
